export const sidebar__data = {
    en: [
            {
                display_name: "Dashboard",
                route: "/",
                icon: "fas fa-th-large"
            },
            {
                display_name: "Customers",
                route: "/customers",
                icon: "far fa-address-book"
            },
            {
                display_name: "Products",
                route: "/products",
                icon: "fas fa-box-open"
            },
            {
                display_name: "Orders",
                route: "/orders",
                icon: "fas fa-shopping-cart"
            },
            {
                display_name: "Analytics",
                route: "/analytics",
                "icon": "fas fa-chart-line"
            },
            {
                display_name: "categories",
                route: "/categories",
                icon: "fas fa-bars"
            },
            {
                display_name: "discount",
                route: "/discount",
                "icon": "fas fa-gift"
            },
            {
                display_name: "inventory",
                route: "/inventory",
                icon: "fas fa-store"
            },
            {
                display_name: "settings",
                route: "/settings",
                icon: "fas fa-cog"
            }
        ],
    ru: [
        {
            display_name: "Щиток приборов",
            route: "/",
            icon: "fas fa-th-large"
        },
        {
            display_name: "Клиенты",
            route: "/customers",
            icon: "far fa-address-book"
        },
        {
            display_name: "Продукты",
            route: "/products",
            icon: "fas fa-box-open"
        },
        {
            display_name: "Заказы",
            route: "/orders",
            icon: "fas fa-shopping-cart"
        },
        {
            display_name: "Аналитика",
            route: "/analytics",
            "icon": "fas fa-chart-line"
        },
        {
            display_name: "Категории",
            route: "/categories",
            icon: "fas fa-bars"
        },
        {
            display_name: "Скидка",
            route: "/discount",
            "icon": "fas fa-gift"
        },
        {
            display_name: "инвентарь",
            route: "/inventory",
            icon: "fas fa-store"
        },
        {
            display_name: "настройки",
            route: "/settings",
            icon: "fas fa-cog"
        }
    ],
    uz: [
        {
            display_name: "asboblar paneli",
            route: "/",
            icon: "fas fa-th-large"
        },
        {
            display_name: "Mijozlar",
            route: "/customers",
            icon: "far fa-address-book"
        },
        {
            display_name: "Mahsulotlar",
            route: "/products",
            icon: "fas fa-box-open"
        },
        {
            display_name: "Buyurtmalar",
            route: "/orders",
            icon: "fas fa-shopping-cart"
        },
        {
            display_name: "Tahlil",
            route: "/analytics",
            "icon": "fas fa-chart-line"
        },
        {
            display_name: "Kategoriyalar",
            route: "/categories",
            icon: "fas fa-bars"
        },
        {
            display_name: "Chegirma",
            route: "/discount",
            "icon": "fas fa-gift"
        },
        {
            display_name: "inventarizatsiya",
            route: "/inventory",
            icon: "fas fa-store"
        },
        {
            display_name: "sozlamalar",
            route: "/settings",
            icon: "fas fa-cog"
        }
    ]
}